<!-- Table content wrapper with loading overlay -->
<div
  class="table-wrapper"
  [class.loading]="loading"
  [style.min-height.px]="containerHeight"
>
  <!-- Loading overlay - preserves the space while showing loading state -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-content">
      <i class="ri-loader-4-line spin"></i>
      {{ 'info.loading_data' | translate }}
    </div>
  </div>

  <!-- Table content - visible but dimmed during loading -->
  <table mat-table #table [dataSource]="invites" class="spotlab-table" style="width: 100%" [class.dimmed]="loading">
    <ng-container matColumnDef="uses">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.uses' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let invite">{{ invite.uses }}</td>
    </ng-container>
    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.code' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let invite" class="code-cell">
        <button
          mat-icon-button
          [cdkCopyToClipboard]="invite.code"
          (cdkCopyToClipboardCopied)="inviteCopied.emit()"
          [matTooltip]="'tooltip.copy_to_clipboard' | translate"
          [matTooltipShowDelay]="1000"
        >
          <i class="ri-file-copy-2-line text-primary"></i>
        </button>
        <span class="cell-text">{{ invite.code }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="link">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.link' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let invite" class="link-cell">
        <ng-container *ngIf="{ mobile: showMobileLayout$ | async } as layout">
          <button
            mat-icon-button
            [cdkCopyToClipboard]="invite.link"
            (cdkCopyToClipboardCopied)="inviteCopied.emit()"
            [matTooltip]="'tooltip.copy_to_clipboard' | translate"
            [matTooltipShowDelay]="1000"
          >
            <i class="text-primary" [class.ri-file-copy-2-line]="!layout.mobile" [class.ri-link-m]="layout.mobile"></i>
          </button>
          <ng-container *ngIf="!layout.mobile">
            <span class="cell-text">{{ invite.link }}</span>
          </ng-container>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="qr">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.qr_code' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let invite">
        <button
          mat-icon-button
          (click)="inviteQRClicked.emit(invite)"
          data-cy="button-invite-qr"
          matTooltip="{{ 'tooltip.show_qr_code' | translate }}"
          [matTooltipShowDelay]="1000"
        >
          <i class="ri-qr-code-line text-primary"></i>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let invite" class="icon-cell">
        <button
          class="icon-button danger"
          type="button"
          (click)="inviteRemoved.emit(invite); $event.stopPropagation()"
          data-cy="invite-delete"
        >
          <i class="ri-delete-bin-6-line"></i>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="['uses', 'code', 'link', 'qr', 'delete']"></tr>
    <tr
      mat-row
      *matRowDef="let invite; columns: ['uses', 'code', 'link', 'qr', 'delete']"
      [class.hoverable-row]="true"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="9999">
        {{ 'placeholder.no_invites' | translate }}
      </td>
    </tr>
  </table>
</div>
